"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evalDatasetFormFilterCols = exports.evalTraceTableCols = exports.datasetOnlyCols = exports.datasetCol = exports.tracesTableCols = exports.tracesOnlyCols = void 0;
exports.datasetFormFilterColsWithOptions = datasetFormFilterColsWithOptions;
exports.tracesTableColsWithOptions = tracesTableColsWithOptions;
const evalExecutionMetadata_1 = require("../features/evals/evalExecutionMetadata");
const typeHelpers_1 = require("./typeHelpers");
exports.tracesOnlyCols = [
    {
        name: "⭐️",
        id: "bookmarked",
        type: "boolean",
        internal: "t.bookmarked",
    },
    { name: "ID", id: "id", type: "string", internal: "t.id" },
    {
        name: "Name",
        id: "traceName",
        type: "stringOptions",
        internal: 't."name"',
        options: [], // to be filled in at runtime
        nullable: true,
        aliases: ["name"],
    },
    {
        name: "Environment",
        id: "environment",
        type: "stringOptions",
        internal: 't."environment"',
        options: [], // to be filled in at runtime
    },
    {
        name: "Timestamp",
        id: "timestamp",
        type: "datetime",
        internal: 't."timestamp"',
    },
    {
        name: "User ID",
        id: "userId",
        type: "string",
        internal: 't."user_id"',
        nullable: true,
    },
    {
        name: "Session ID",
        id: "sessionId",
        type: "string",
        internal: 't."session_id"',
        nullable: true,
    },
    {
        name: "Metadata",
        id: "metadata",
        type: "stringObject",
        internal: 't."metadata"',
    },
    {
        name: "Evaluator ID",
        id: "evaluatorId",
        type: "stringOptions",
        internal: `t.metadata['${evalExecutionMetadata_1.EvalExecutionMetadataKey.EVALUATOR_ID}']`,
        options: [],
    },
    {
        name: "Rule ID",
        id: "ruleId",
        type: "stringOptions",
        internal: `if(notEmpty(t.metadata['${evalExecutionMetadata_1.EvalExecutionMetadataKey.EVALUATION_RULE_ID}']), t.metadata['${evalExecutionMetadata_1.EvalExecutionMetadataKey.EVALUATION_RULE_ID}'], t.metadata['${evalExecutionMetadata_1.EvalExecutionMetadataKey.JOB_CONFIGURATION_ID}'])`,
        options: [],
    },
    {
        name: "Version",
        id: "version",
        type: "string",
        internal: 't."version"',
        nullable: true,
    },
    {
        name: "Release",
        id: "release",
        type: "string",
        internal: 't."release"',
        nullable: true,
    },
    {
        name: "Status",
        id: "level",
        type: "stringOptions",
        internal: '"level"',
        options: [
            { value: "DEBUG" },
            { value: "DEFAULT" },
            { value: "WARNING" },
            { value: "ERROR" },
        ],
        aliases: ["Level"],
    },
    {
        name: "Tags",
        id: "traceTags",
        type: "arrayOptions",
        internal: 't."tags"',
        options: [], // to be filled in at runtime
        aliases: ["tags"],
    },
];
exports.tracesTableCols = [
    ...exports.tracesOnlyCols,
    {
        name: "Input Tokens",
        id: "inputTokens",
        type: "number",
        step: 1,
        internal: 'generation_metrics."promptTokens"',
        nullable: true,
    },
    {
        name: "Output Tokens",
        id: "outputTokens",
        type: "number",
        step: 1,
        internal: 'generation_metrics."completionTokens"',
        nullable: true,
    },
    {
        name: "Error Level Count",
        id: "errorCount",
        type: "number",
        step: 1,
        internal: 'generation_metrics."errorCount"',
    },
    {
        name: "Warning Level Count",
        id: "warningCount",
        type: "number",
        step: 1,
        internal: 'generation_metrics."warningCount"',
    },
    {
        name: "Default Level Count",
        id: "defaultCount",
        type: "number",
        step: 1,
        internal: 'generation_metrics."defaultCount"',
    },
    {
        name: "Debug Level Count",
        id: "debugCount",
        type: "number",
        step: 1,
        internal: 'generation_metrics."debugCount"',
    },
    {
        name: "Total Tokens",
        id: "totalTokens",
        type: "number",
        step: 1,
        internal: 'generation_metrics."totalTokens"',
        nullable: true,
    },
    {
        name: "Tokens",
        id: "tokens",
        type: "number",
        step: 1,
        internal: 'generation_metrics."totalTokens"',
        nullable: true,
    },
    {
        name: "Scores (numeric)",
        id: "scores_avg",
        type: "numberObject",
        internal: "scores_avg",
    },
    {
        name: "Scores (categorical)",
        id: "score_categories",
        type: "categoryOptions",
        internal: "score_categories",
        options: [], // to be filled in at runtime
        nullable: true,
    },
    {
        name: "Scores (boolean)",
        id: "score_booleans",
        type: "booleanObject",
        internal: "score_booleans",
        nullable: true,
    },
    {
        name: "Latency (s)",
        id: "latency",
        type: "number",
        internal: "observation_metrics.latency",
    },
    {
        name: "Input Cost ($)",
        id: "inputCost",
        type: "number",
        internal: '"calculatedInputCost"',
        nullable: true,
    },
    {
        name: "Output Cost ($)",
        id: "outputCost",
        type: "number",
        internal: '"calculatedOutputCost"',
        nullable: true,
    },
    {
        name: "Total Cost ($)",
        id: "totalCost",
        type: "number",
        internal: '"calculatedTotalCost"',
        nullable: true,
    },
    {
        name: "Comment Count",
        id: "commentCount",
        type: "number",
        step: 1,
        internal: "", // handled by comment filter helpers
    },
    {
        name: "Comment Content",
        id: "commentContent",
        type: "string",
        internal: "", // handled by comment filter helpers
    },
];
exports.datasetCol = {
    name: "Dataset",
    id: "datasetId",
    type: "stringOptions",
    internal: 'di."dataset_id"',
    options: [], // to be filled in at runtime
};
// Used only for dataset evaluator, not on dataset table
exports.datasetOnlyCols = [exports.datasetCol];
/** @alias */
exports.evalTraceTableCols = exports.tracesOnlyCols;
/** @alias */
exports.evalDatasetFormFilterCols = exports.datasetOnlyCols;
// Used only for dataset evaluator, not on dataset table
function datasetFormFilterColsWithOptions(options, cols = exports.evalDatasetFormFilterCols) {
    return cols.map((col) => {
        if (col.id === "datasetId") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.datasetId ?? []);
        }
        return col;
    });
}
function tracesTableColsWithOptions(options, cols = exports.tracesTableCols) {
    return cols.map((col) => {
        if (col.id === "scores_avg") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.scores_avg ?? []);
        }
        if (col.id === "traceName") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.traceName ?? []);
        }
        if (col.id === "traceTags") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.traceTags ?? []);
        }
        if (col.id === "environment") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.environment ?? []);
        }
        if (col.id === "score_categories") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.score_categories ?? []);
        }
        if (col.id === "score_booleans") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.score_booleans ?? []);
        }
        return col;
    });
}
